var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuizzesHomeworksWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1143",
    "data-name": "Group 1143",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.906,
    height: 15.805,
    viewBox: "0 0 11.906 15.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_382",
    "data-name": "Rectangle 382",
    width: 11.906,
    height: 15.805,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M55.641,447.906H46.173v-.868c0-1.559,1.793-3.115,3.287-3.218.44-.03.291.057.526.29a1.351,1.351,0,0,0,1.824.017c.267-.251.094-.342.574-.3,1.486.122,3.257,1.659,3.257,3.214Z",
    transform: "translate(-44.954 -432.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M120.033,128.176l-3.307.008c-.159-.2-.383-.348-.552-.545a2.9,2.9,0,1,1,4.394,0c-.165.192-.393.338-.535.537m-1.536-1.535c.091-.112.005-.308.061-.4.026-.043.3-.146.375-.2a1.074,1.074,0,0,0-1.241-1.752c-.3.2-.764,1.013-.267,1.151.337.094.3-.325.382-.491a.536.536,0,1,1,.933.525c-.191.324-.66.145-.708.45a2.968,2.968,0,0,0,.016.661.289.289,0,0,0,.449.059m-.271.254c-.311.064-.237.607.12.533a.273.273,0,0,0-.12-.533",
    transform: "translate(-112.418 -119.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M176.653,345.936c-.054.195-.02.389-.078.586a.921.921,0,0,1-.891.641,2.2,2.2,0,0,1-1.412-.226c-.31-.263-.292-.635-.343-1Z",
    transform: "translate(-169.338 -336.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M198.164,410.36c.01,0,.038-.051.051-.034a.781.781,0,1,1-1.5,0c.012-.017.043.034.051.034a12.556,12.556,0,0,0,1.4,0",
    transform: "translate(-191.513 -399.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M63.968,338.157c.272-.057.415.241.263.47a8.724,8.724,0,0,1-.766.766c-.28.185-.581-.059-.437-.335a11.057,11.057,0,0,1,.812-.822.321.321,0,0,1,.128-.079",
    transform: "translate(-61.328 -329.225)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M338.925,338.145a.249.249,0,0,1,.23.062,10,10,0,0,1,.816.819c.174.273-.129.549-.423.354a8.733,8.733,0,0,1-.766-.766.292.292,0,0,1,.142-.47",
    transform: "translate(-329.78 -329.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M63.369,63.144a.29.29,0,0,1,.233.025c.2.278.652.566.833.836.166.249-.087.527-.38.381a7.778,7.778,0,0,1-.778-.755c-.123-.173-.163-.428.092-.486",
    transform: "translate(-61.513 -61.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M339.655,62.95c.291-.088.481.175.311.447a7.019,7.019,0,0,1-.747.752c-.3.207-.576,0-.454-.317.178-.127.743-.837.89-.882",
    transform: "translate(-329.796 -61.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M215,.009a.269.269,0,0,1,.351.248,7.944,7.944,0,0,1,0,1.158.287.287,0,0,1-.526.051,9.258,9.258,0,0,1-.016-1.24A.262.262,0,0,1,215,.009",
    transform: "translate(-209.128 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M.187,214.964a9.169,9.169,0,0,1,1.252-.006c.264.05.243.493-.069.542a7.54,7.54,0,0,1-1.149-.005c-.272-.061-.3-.47-.034-.53",
    transform: "translate(0 -209.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M389.742,214.878c.368.036.937-.076,1.28,0,.279.062.238.488-.063.536a7.542,7.542,0,0,1-1.149-.005.284.284,0,0,1-.068-.531",
    transform: "translate(-379.304 -209.181)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizzesHomeworksWhite);
export default __webpack_public_path__ + "static/media/QuizzesHomeworksWhite.5691c55b264edfe68b60a6f8e465b6ef.svg";
export { ForwardRef as ReactComponent };